
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("Vjn6T", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $inPa6 = parcelRequire("inPa6");


var $7Sm4c = parcelRequire("7Sm4c");


var $hYoU4 = parcelRequire("hYoU4");


var $2HGN8 = parcelRequire("2HGN8");


var $7aRa9 = parcelRequire("7aRa9");


var $1d2ww = parcelRequire("1d2ww");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $6fil2 = parcelRequire("6fil2");


var $5kqgA = parcelRequire("5kqgA");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");











var $3gadb = parcelRequire("3gadb");


var $4KS7f = parcelRequire("4KS7f");


var $1kVeP = parcelRequire("1kVeP");


var $64M9v = parcelRequire("64M9v");








var $8VcPj = parcelRequire("8VcPj");

const $9a3dfb9c288320c5$export$36c1915a504dc477 = ({ children: children, userOffline: userOffline, params: params, collabEditProvider: collabEditProvider, currentContentAppearance: currentContentAppearance, setContentAppearance: setContentAppearance })=>{
    const [shouldFetchAppearance, setShouldFetchAppearance] = (0, $42omo.useState)(false);
    const fetchAndUpdateAfterOffline = async ()=>{
        const appearanceProperty = await (0, $8VcPj.fetchContentAppearanceProperty)(params.contentId, params.propertyKey, 'network-only');
        const currentStateVersion = currentContentAppearance?.version || 0;
        if (appearanceProperty?.version > currentStateVersion) {
            const newParams = {
                ...params,
                propertyValue: appearanceProperty.appearance,
                versionNumber: appearanceProperty.version
            };
            // Just need to update the state if it's out of date, no need to perform a mutation to update the current view
            setContentAppearance(appearanceProperty);
            (0, $8VcPj.updateAppearanceForCollab)(collabEditProvider, newParams);
        }
    };
    (0, $42omo.useEffect)(()=>{
        // should refetch contentAppearanceProperty after user reconnected
        setShouldFetchAppearance(!!userOffline);
    }, [
        userOffline
    ]);
    if (!userOffline && shouldFetchAppearance) fetchAndUpdateAfterOffline();
    return children;
};








const $7b6fda5754d8dda7$var$i18n = (0, $aXWIB.defineMessages)({
    fixedWidth: {
        id: "editor-appearance-button.toggle.fixed.width",
        defaultMessage: "Make full-width"
    },
    fullWidth: {
        id: "editor-appearance-button.toggle.full.width",
        defaultMessage: "Make fixed-width"
    }
});
const $7b6fda5754d8dda7$export$c864be1599adc41 = ({ contentAppearanceDraft: contentAppearanceDraft, contentId: contentId, updateContentAppearanceProperty: updateContentAppearanceProperty, collabEditProvider: collabEditProvider, isDisabled: isDisabled, isStatusDisconnected: isStatusDisconnected, setContentAppearance: setContentAppearance })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [shouldDisableButton, setShouldDisableButton] = (0, $42omo.useState)(false);
    const buttonRef = (0, $42omo.useRef)(null);
    const isFullWidth = contentAppearanceDraft.appearance === (0, $1d2ww.ContentAppearanceType).FULL_WIDTH;
    const i18nTooltipTextMessage = isFullWidth ? $7b6fda5754d8dda7$var$i18n.fullWidth : $7b6fda5754d8dda7$var$i18n.fixedWidth;
    const tooltipText = formatMessage(i18nTooltipTextMessage);
    const triggerAnalyticsEvent = (0, $42omo.useCallback)((eventName, extraData = {})=>{
        const analyticDetails = {
            contentId: contentId,
            ...extraData
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: eventName,
                actionSubject: 'updateContentAppearanceDraft',
                source: 'EditContentAppearanceButtonComponent',
                attributes: analyticDetails
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const getToggleWidthParams = (0, $42omo.useCallback)(()=>{
        const newAppearance = isFullWidth ? (0, $1d2ww.ContentAppearanceType).DEFAULT : (0, $1d2ww.ContentAppearanceType).FULL_WIDTH;
        const newVersion = contentAppearanceDraft.version ? contentAppearanceDraft.version + 1 : 1;
        return {
            contentId: contentId || '',
            propertyKey: (0, $1d2ww.ContentAppearancePropertyKey).DRAFT,
            propertyValue: newAppearance,
            versionNumber: newVersion
        };
    }, [
        contentId,
        contentAppearanceDraft,
        isFullWidth
    ]);
    const toggleWidth = (0, $42omo.useCallback)(async ()=>{
        const wasFocused = document.activeElement === buttonRef.current;
        if (contentId) {
            // Disable button to prevent clicks on it while mutation is occurring to prevent 409s
            setShouldDisableButton(true);
            let params = getToggleWidthParams();
            params = await (0, $8VcPj.updateContentAppearancePropertyWithRetry)(updateContentAppearanceProperty, params, collabEditProvider);
            setShouldDisableButton(false);
            triggerAnalyticsEvent('content.appearance.draft', {
                appearance: params.propertyValue,
                previousAppearance: contentAppearanceDraft.appearance,
                appearanceVersion: params.versionNumber
            });
            if (wasFocused) buttonRef.current?.focus();
        }
    }, [
        contentId,
        contentAppearanceDraft,
        updateContentAppearanceProperty,
        collabEditProvider,
        getToggleWidthParams,
        triggerAnalyticsEvent
    ]);
    const getButtonIcon = (0, $42omo.useCallback)(()=>{
        if (isFullWidth) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($64M9v))), {
            color: "currentColor",
            spacing: "spacious",
            label: tooltipText
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
            color: "currentColor",
            spacing: "spacious",
            label: tooltipText
        });
    }, [
        isFullWidth,
        tooltipText
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9a3dfb9c288320c5$export$36c1915a504dc477), {
        userOffline: isStatusDisconnected,
        params: getToggleWidthParams(),
        collabEditProvider: collabEditProvider,
        currentContentAppearance: contentAppearanceDraft,
        setContentAppearance: setContentAppearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: tooltipText,
        tag: "span",
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        interactionName: (0, $6mKj3.expValEquals)('cc_editor_ttvc_appearance_toggle', 'isEnabled', true) ? 'editor-appearance-change_toggle' : undefined,
        ref: buttonRef,
        appearance: "subtle",
        iconBefore: getButtonIcon(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            minWidth: 36
        },
        onClick: toggleWidth,
        isDisabled: shouldDisableButton || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        !Boolean(window.__SSR_RENDERED__) && isDisabled,
        "data-test-id": "editor-appearance-button"
    })));
};


/* EditorAppearanceDropdownComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $52EPl = parcelRequire("52EPl");


var $dAYOx = parcelRequire("dAYOx");


var $ahaN7 = parcelRequire("ahaN7");


var $ccHMk = parcelRequire("ccHMk");





var $ghftu = parcelRequire("ghftu");


var $bYRk6 = parcelRequire("bYRk6");







var $1s5hv = parcelRequire("1s5hv");











const $94791839286023cd$var$messages = (0, $aXWIB.defineMessages)({
    adjustWidthButtonLabel: {
        id: "editor-appearance-button.max-width.adjust-width-label",
        defaultMessage: "Adjust width"
    },
    fullPageLabel: {
        id: "editor-appearance-button.max-width.narrow-label",
        defaultMessage: "Narrow"
    },
    fullWidthLabel: {
        id: "editor-appearance-button.max-width.wide-label",
        defaultMessage: "Wide"
    },
    maxLabel: {
        id: "editor-appearance-button.max-width.max-label",
        defaultMessage: "Max"
    },
    dropdownAriaLabel: {
        id: "editor-appearance-button.max-width.dropdown-aria-label",
        defaultMessage: "Page width options"
    }
});
/**
 * This container with "relative" positioning
 * is necessary for the top border on scroll to
 * correctly anchor itself
 */ const $94791839286023cd$var$styles = {
    dropdownButtonFlexGroupStyles: "_4t3igktf"
};
const $94791839286023cd$var$analyticsContextData = {
    packageName: '@confluence/editor-appearance-button',
    packageVersion: '0.0.1'
};
const $94791839286023cd$export$cb4106f08400ee9b = ({ contentAppearanceDraft: contentAppearanceDraft, contentId: contentId, updateContentAppearanceProperty: updateContentAppearanceProperty, collabEditProvider: collabEditProvider, isDisabled: isDisabled, isStatusDisconnected: isStatusDisconnected, setContentAppearance: setContentAppearance, setIsAppearanceDropdownOpen: setIsAppearanceDropdownOpen, isAppearanceDropdownOpen: isAppearanceDropdownOpen, onAppearanceUpdateSuccess: onAppearanceUpdateSuccess })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [shouldDisableButton, setShouldDisableButton] = (0, $42omo.useState)(false);
    const [currentAppearance, setCurrentAppearance] = (0, $42omo.useState)(contentAppearanceDraft.appearance);
    (0, $42omo.useEffect)(()=>{
        setCurrentAppearance(contentAppearanceDraft.appearance);
    }, [
        contentAppearanceDraft.appearance
    ]);
    const triggerAnalyticsEvent = (0, $42omo.useCallback)((eventName, extraData = {})=>{
        const analyticDetails = {
            contentId: contentId,
            ...extraData
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: eventName,
                actionSubject: 'updateContentAppearanceDraft',
                source: 'EditContentAppearanceButtonComponent',
                attributes: analyticDetails
            }
        }).fire();
    }, [
        contentId,
        createAnalyticsEvent
    ]);
    const getToggleWidthParams = (0, $42omo.useCallback)(()=>{
        const newVersion = contentAppearanceDraft.version ? contentAppearanceDraft.version + 1 : 1;
        return {
            contentId: contentId || '',
            propertyKey: (0, $1d2ww.ContentAppearancePropertyKey).DRAFT,
            propertyValue: currentAppearance,
            versionNumber: newVersion
        };
    }, [
        contentAppearanceDraft.version,
        contentId,
        currentAppearance
    ]);
    const toggleWidth = (0, $42omo.useCallback)(async (newAppearance)=>{
        if (contentId) {
            // Disable button to prevent clicks on it while mutation is occurring to prevent 409s
            setShouldDisableButton(true);
            setCurrentAppearance(newAppearance);
            let params = getToggleWidthParams();
            params = await (0, $8VcPj.updateContentAppearancePropertyWithRetry)(updateContentAppearanceProperty, {
                ...params,
                propertyValue: newAppearance
            }, collabEditProvider);
            setShouldDisableButton(false);
            triggerAnalyticsEvent('content.appearance.draft', {
                appearance: params.propertyValue,
                previousAppearance: contentAppearanceDraft.appearance,
                appearanceVersion: params.versionNumber
            });
            onAppearanceUpdateSuccess?.(params.propertyValue);
        }
    }, [
        contentId,
        getToggleWidthParams,
        updateContentAppearanceProperty,
        collabEditProvider,
        triggerAnalyticsEvent,
        contentAppearanceDraft.appearance,
        onAppearanceUpdateSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: $94791839286023cd$var$analyticsContextData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9a3dfb9c288320c5$export$36c1915a504dc477), {
        userOffline: isStatusDisconnected,
        params: getToggleWidthParams(),
        collabEditProvider: collabEditProvider,
        currentContentAppearance: contentAppearanceDraft,
        setContentAppearance: setContentAppearance
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                content: intl.formatMessage($94791839286023cd$var$messages.adjustWidthButtonLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                ref: triggerRef,
                appearance: "subtle",
                spacing: "default",
                isDisabled: shouldDisableButton || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
                !Boolean(window.__SSR_RENDERED__) && isDisabled,
                "aria-label": intl.formatMessage($94791839286023cd$var$messages.adjustWidthButtonLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
                gap: "space.050",
                alignItems: "center",
                xcss: $94791839286023cd$var$styles.dropdownButtonFlexGroupStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kVeP))), {
                label: "",
                "aria-hidden": "true",
                size: "medium"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                label: "",
                "aria-hidden": "true",
                size: "small"
            })))),
        placement: "bottom-start",
        onOpenChange: (onOpenChangeArgs)=>{
            setIsAppearanceDropdownOpen?.(onOpenChangeArgs.isOpen);
        },
        isOpen: isAppearanceDropdownOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        interactionName: (0, $6mKj3.expValEquals)('cc_editor_ttvc_appearance_toggle', 'isEnabled', true) ? 'editor-appearance-change_default' : undefined,
        onClick: ()=>toggleWidth((0, $1d2ww.ContentAppearanceType).DEFAULT),
        isSelected: currentAppearance === (0, $1d2ww.ContentAppearanceType).DEFAULT
    }, intl.formatMessage($94791839286023cd$var$messages.fullPageLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        interactionName: (0, $6mKj3.expValEquals)('cc_editor_ttvc_appearance_toggle', 'isEnabled', true) ? 'editor-appearance-change_full-width' : undefined,
        onClick: ()=>toggleWidth((0, $1d2ww.ContentAppearanceType).FULL_WIDTH),
        isSelected: currentAppearance === (0, $1d2ww.ContentAppearanceType).FULL_WIDTH
    }, intl.formatMessage($94791839286023cd$var$messages.fullWidthLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        interactionName: (0, $6mKj3.expValEquals)('cc_editor_ttvc_appearance_toggle', 'isEnabled', true) ? 'editor-appearance-change_max' : undefined,
        onClick: ()=>toggleWidth((0, $1d2ww.ContentAppearanceType).MAX),
        isSelected: currentAppearance === (0, $1d2ww.ContentAppearanceType).MAX
    }, intl.formatMessage($94791839286023cd$var$messages.maxLabel))))));
};


const $b6a305a656accd1c$export$a7357cdd1f0b0168 = (0, $aXWIB.defineMessages)({
    errorFlagTitle: {
        id: "editor-appearance-button.error.flag.title",
        defaultMessage: "Unable to update width"
    },
    unauthorizedErrorFlagBody: {
        id: "editor-appearance-button.unauthorized.error.flag.body",
        defaultMessage: "You don\u2019t have permission to update the width. Contact your admin to request access."
    },
    networkErrorFlagBody: {
        id: "editor-appearance-button.network.error.flag.body",
        defaultMessage: "Check your internet connection, refresh, and try again."
    },
    widthChangeFlagTitleNarrow: {
        id: "editor-appearance-button.max-width.width-change.flag.description.narrow",
        defaultMessage: "Narrow width applied"
    },
    widthChangeFlagTitleWide: {
        id: "editor-appearance-button.max-width.width-change.flag.description.wide",
        defaultMessage: "Wide width applied"
    },
    widthChangeFlagTitleMax: {
        id: "editor-appearance-button.max-width.width-change.flag.description.max",
        defaultMessage: "Max width applied"
    },
    widthChangeFlagTitleGeneric: {
        id: "editor-appearance-button.max-width.width-change.flag.description.generic",
        defaultMessage: "Width updated"
    }
});
const $b6a305a656accd1c$var$WIDTH_CHANGE_FLAG_ID = 'editor-appearance-width-change-flag';
const $b6a305a656accd1c$var$widthChangeFlagMessages = {
    [(0, $1d2ww.ContentAppearanceType).DEFAULT]: $b6a305a656accd1c$export$a7357cdd1f0b0168.widthChangeFlagTitleNarrow,
    [(0, $1d2ww.ContentAppearanceType).FULL_WIDTH]: $b6a305a656accd1c$export$a7357cdd1f0b0168.widthChangeFlagTitleWide,
    [(0, $1d2ww.ContentAppearanceType).MAX]: $b6a305a656accd1c$export$a7357cdd1f0b0168.widthChangeFlagTitleMax
};
const $b6a305a656accd1c$var$getWidthChangeFlagMessage = (appearance)=>$b6a305a656accd1c$var$widthChangeFlagMessages[appearance] ?? $b6a305a656accd1c$export$a7357cdd1f0b0168.widthChangeFlagTitleGeneric;
const $b6a305a656accd1c$var$EditorAppearanceButtonNextComponent = ({ contentId: contentId, isStatusDisconnected: isStatusDisconnected, flags: flags, disabled: disabled = false, setIsAppearanceDropdownOpen: setIsAppearanceDropdownOpen, isAppearanceDropdownOpen: isAppearanceDropdownOpen })=>{
    const intl = (0, $aXWIB.useIntl)();
    const { contentAppearance: contentAppearance, setContentAppearance: setContentAppearance, contentAppearanceLoading: contentAppearanceLoading } = (0, $2HGN8.useContentAppearance)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ collabEditProvider: collabEditProvider, collabEditInitialized: collabEditInitialized }] = (0, $hYoU4.useNativeCollabState)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const { updateContentProperty: updateContentProperty, processUpdateContentPropertyResult: processUpdateContentPropertyResult } = (0, $5kqgA.useUpdateContentProperty)({
        contentId: contentId,
        contentType: contentType || 'page'
    });
    const updateContentAppearanceProperty = async (params)=>{
        try {
            const result = await updateContentProperty({
                propertyKey: params.propertyKey,
                propertyValue: params.propertyValue,
                isDelete: false,
                hasExistingProperty: contentAppearance.version > 0
            });
            const responseData = processUpdateContentPropertyResult(result?.data);
            if (responseData?.success) setContentAppearance({
                appearance: params.propertyValue,
                version: params.versionNumber
            });
            else if (responseData?.errors?.[0]) {
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'updateContentAppearanceProperty',
                        source: 'EditorAppearanceButtonNext',
                        attributes: {
                            error: responseData.errors[0]
                        }
                    }
                }).fire();
                const statusCode = responseData.errors[0].extensions?.statusCode;
                if (String(statusCode) === '409') // Not showing flag for 409s since it's not a user error but something that's happening on our end
                return;
                else {
                    const flagBodyText = String(statusCode) === '403' ? $b6a305a656accd1c$export$a7357cdd1f0b0168.unauthorizedErrorFlagBody : $b6a305a656accd1c$export$a7357cdd1f0b0168.networkErrorFlagBody;
                    flags.showErrorFlag({
                        id: 'content-appearance-button-conflict-error-flag',
                        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b6a305a656accd1c$export$a7357cdd1f0b0168.errorFlagTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), flagBodyText)
                    });
                }
            }
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'updateContentAppearanceProperty',
                    source: 'EditorAppearanceButtonNext',
                    attributes: {
                        error: error
                    }
                }
            }).fire();
            const is409Error = (0, $aMcHK.isStatusCodeError)(error, '409');
            const is403Error = (0, $1uFM6.isUnauthorizedError)(error);
            const isNetworkError = (0, $6fil2.containsNetworkError)(error);
            // Not showing flag for 409s since it's not a user error but something that's happening on our end
            if (is409Error) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return;
            }
            if (is403Error || isNetworkError) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                const flagBodyText = is403Error ? $b6a305a656accd1c$export$a7357cdd1f0b0168.unauthorizedErrorFlagBody : $b6a305a656accd1c$export$a7357cdd1f0b0168.networkErrorFlagBody;
                flags.showErrorFlag({
                    id: 'content-appearance-button-conflict-error-flag',
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $b6a305a656accd1c$export$a7357cdd1f0b0168.errorFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), flagBodyText)
                });
            }
        }
    };
    const isDisabled = contentAppearanceLoading || !collabEditInitialized || disabled;
    const handleAppearanceUpdateSuccess = (appearance)=>{
        if (!(0, $6mKj3.expValEquals)('confluence_width_change_info_flag', 'isEnabled', true)) return;
        const titleMessage = $b6a305a656accd1c$var$getWidthChangeFlagMessage(appearance);
        const title = intl.formatMessage(titleMessage);
        flags?.showInfoFlag?.({
            id: $b6a305a656accd1c$var$WIDTH_CHANGE_FLAG_ID,
            title: title,
            isAutoDismiss: true
        });
    };
    if ((0, $6mKj3.expValEquals)('editor_tinymce_full_width_mode', 'isEnabled', true) || (0, $6mKj3.expValEquals)('confluence_max_width_content_appearance', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $94791839286023cd$export$cb4106f08400ee9b), {
        contentId: contentId,
        collabEditProvider: collabEditProvider,
        isDisabled: isDisabled,
        isStatusDisconnected: isStatusDisconnected,
        updateContentAppearanceProperty: updateContentAppearanceProperty,
        contentAppearanceDraft: contentAppearance,
        setContentAppearance: setContentAppearance,
        setIsAppearanceDropdownOpen: setIsAppearanceDropdownOpen,
        isAppearanceDropdownOpen: isAppearanceDropdownOpen,
        onAppearanceUpdateSuccess: (0, $6mKj3.expValEquals)('confluence_width_change_info_flag', 'isEnabled', true) ? handleAppearanceUpdateSuccess : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7b6fda5754d8dda7$export$c864be1599adc41), {
        contentId: contentId,
        collabEditProvider: collabEditProvider,
        isDisabled: isDisabled,
        isStatusDisconnected: isStatusDisconnected,
        updateContentAppearanceProperty: updateContentAppearanceProperty,
        contentAppearanceDraft: contentAppearance,
        setContentAppearance: setContentAppearance
    });
};
const $b6a305a656accd1c$export$b00e22884b6dd9a = (0, $7aRa9.withFlags)($b6a305a656accd1c$var$EditorAppearanceButtonNextComponent);
module.exports["EditorAppearanceButtonNext"] = $b6a305a656accd1c$export$b00e22884b6dd9a;

});


//# sourceMappingURL=EditorAppearanceButtonNext.1b1a597a.js.map
